import { Product, Variant } from "../../types/types";

export function hasColours(product: Product): boolean {
  return Boolean(product.variants?.some(variantHasColours));
}

function variantHasColours(variant: Variant): boolean {
  return Boolean(variant.differentiators?.colour);
}
